module.exports = __webpack_public_path__ + "static/media/bgapropos.d207d82d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header_bg/bgapropos.png
// module id = 2287
// module chunks = 0